import PropTypes from 'prop-types';
import React from 'react';
import ContactInformation from '../containers/ContactInformationContainer';
import UpdateCardButton from './UpdateCardButton';
import Container from './Container';
import Section from './Section';
import CardInfoModal from './CardInfoModal';
import SuccessAlert from './SuccessAlert';
import { successMessage } from '../uiHelpers';

const UpdateCustomerInfo = ({
  formDisabled,
  toggled,
  on,
  off,
  confirmSetup,
  isSuccess,
  onSuccess,
  children,
 }) => (
   <div>
     <Container>
       <Section>
         {children}
       </Section>

       <Section>
         <ContactInformation />
       </Section>

       <UpdateCardButton
         disabled={formDisabled}
         onClick={on}
       >
        Update Credit Card
      </UpdateCardButton>

       <SuccessAlert show={isSuccess} text={successMessage} onConfirm={onSuccess} />
       {toggled && <CardInfoModal off={off} confirmSetup={confirmSetup} />}
     </Container>
   </div>
);

UpdateCustomerInfo.propTypes = {
  off: PropTypes.func.isRequired,
  on: PropTypes.func.isRequired,
  toggled: PropTypes.bool,
  confirmSetup: PropTypes.func.isRequired,
  formDisabled: PropTypes.bool,
  isSuccess: PropTypes.bool,
  onSuccess: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

UpdateCustomerInfo.defaultProps = {
  formDisabled: false,
  toggled: false,
  isSuccess: false,
};

export default UpdateCustomerInfo;



// WEBPACK FOOTER //
// ./src/app/membership/UpdateCustomerInfo/components/UpdateCustomerInfo.jsx